<key-form-builder #formBuilder
    [inline]="true"
    [form]="form()"
    [values]="formValues()"
    (onChange)="handleSettingsChange()">
</key-form-builder>